function Mug() {
  return (
    <div className="mug">
      <div className="mug__handle"></div>
      <div className="mug__cup">
        <div className="mug__wall">
          <div className="mug__coffee">
            <div className="mug__steam"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Mug;
